import request from '@/utils/request'

export const formApi = {
  // 获取表单列表
  getForms(params) {
    return request({
      url: '/forms/',
      method: 'get',
      params
    })
  },

  // 获取单个表单详情
  getForm(id) {
    return request({
      url: `/forms/${id}/`,
      method: 'get'
    })
  },

  // 创建表单
  createForm(data) {
    return request({
      url: '/forms/',
      method: 'post',
      data
    })
  },

  // 更新表单
  updateForm(id, data) {
    return request({
      url: `/forms/${id}/`,
      method: 'put',
      data
    })
  },

  // 删除表单
  deleteForm(id) {
    return request({
      url: `/forms/${id}/`,
      method: 'delete'
    })
  },

  // 提交表单数据
  submitForm(id, data) {
    return request({
      url: `/forms/${id}/submit/`,
      method: 'post',
      data
    })
  },

  // 获取表单提交记录
  getSubmissions(id, params) {
    return request({
      url: `/forms/${id}/submissions/`,
      method: 'get',
      params
    })
  },

  // 获取最新提交记录
  getLatestSubmission(id) {
    return request({
      url: `/forms/${id}/latest_submission/`,
      method: 'get'
    })
  },
  // 获取活动的表单列表（用于生成菜单）
  getActiveFormMenus() {
    return request({
      url: '/forms/',
      method: 'get',
      params: {
        is_active: true,
        page_size: 100 // 获取足够多的记录用于生成菜单
      }
    })
  },

  // 更新提交记录
  updateSubmission(id, data) {
    return request({
      url: `/forms/form-submissions/${id}/`,
      method: 'patch',
      data
    })
  },

  // 删除提交记录
  deleteSubmission(id) {
    return request({
      url: `/forms/form-submissions/${id}/`,
      method: 'delete'
    })
  },

  // 批量删除提交记录
  batchDeleteSubmissions(ids) {
    return request({
      url: '/forms/form-submissions/batch_delete/',
      method: 'post',
      data: { ids }
    })
  }
} 